import { css, cx } from '@fable/theme'
import { CompProps } from '@fable/types'
import { motion, MotionProps } from 'framer-motion'

interface Props extends MotionProps {
  className?: string
  inView: boolean
}

export const StreakCalendarMotion = ({
  className = '',
  inView = false,
  children,
  ...props
}: CompProps<Props>) => (
  <motion.div
    className={cx(
      css`
        width: 100%;
        height: 100%;
      `,
      className
    )}
    variants={{
      hidden: { opacity: 0 },
      visible: { opacity: 1 },
    }}
    initial="hidden"
    animate={inView ? 'visible' : 'hidden'}
    transition={{ duration: 0.3 }}
    {...props}
  >
    {children}
  </motion.div>
)
